(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ncc-lead-popup"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
      var dialog = document.getElementById('ncc-lead-popup');
      if (!dialog || typeof dialog.showModal !== 'function') return;

      var STORAGE_KEY = 'ncc_lead_popup_submitted';
      var DISMISS_KEY = 'ncc_lead_popup_dismiss_count';
      var MAX_DISMISSALS = 2;

      function markSubmitted() {
        try {
          window.localStorage.setItem(STORAGE_KEY, '1');
        } catch (e) {}
      }

      function getDismissCount() {
        try {
          return parseInt(window.sessionStorage.getItem(DISMISS_KEY), 10) || 0;
        } catch (e) {
          return 0;
        }
      }

      function markDismissed() {
        try {
          window.sessionStorage.setItem(DISMISS_KEY, String(getDismissCount() + 1));
        } catch (e) {}
      }

      function closePopup() {
        if (dialog.open) dialog.close();
      }

      function dismissPopup() {
        markDismissed();
        closePopup();
      }

      var closeBtn = dialog.querySelector('[data-ncc-popup-close]');
      if (closeBtn) {
        closeBtn.addEventListener('click', dismissPopup);
      }

      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) dismissPopup();
      });

      var form = dialog.querySelector('form');
      var phoneInput = document.getElementById('ncc-popup-phone');
      var noteInput = document.getElementById('ncc-popup-note');
      if (form && phoneInput && noteInput) {
        form.addEventListener('submit', function () {
          noteInput.value = phoneInput.value ? 'Phone: ' + phoneInput.value : '';
        });
      }

      var hasSuccess = !!dialog.querySelector('[data-ncc-popup-success]');
      var hasError = !!dialog.querySelector('[data-ncc-popup-error]');

      if (hasSuccess) {
        markSubmitted();
        dialog.showModal();
        window.setTimeout(closePopup, 3000);
        return;
      }

      if (hasError) {
        dialog.showModal();
        return;
      }

      var alreadySubmitted = false;
      try {
        alreadySubmitted = window.localStorage.getItem(STORAGE_KEY) === '1';
      } catch (e) {}
      if (alreadySubmitted) return;

      if (getDismissCount() >= MAX_DISMISSALS) return;

      window.setTimeout(function () {
        if (!dialog.open) dialog.showModal();
      }, 1500);
    });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ncc-scripts"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
  var navToggle = document.querySelector('[data-ncc-nav-toggle]');
  var mobileNav = document.querySelector('[data-ncc-mobile-nav]');
  if (navToggle && mobileNav) {
    navToggle.addEventListener('click', function () {
      var isOpen = mobileNav.classList.toggle('is-open');
      navToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
    mobileNav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        mobileNav.classList.remove('is-open');
        navToggle.setAttribute('aria-expanded', 'false');
      });
    });
  }

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var revealTargets = document.querySelectorAll('.ncc-reveal');
  if (revealTargets.length) {
    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      revealTargets.forEach(function (el) { el.classList.add('is-visible'); });
    } else {
      var revealObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              revealObserver.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.1, rootMargin: '0px 0px -60px 0px' }
      );
      revealTargets.forEach(function (el) { revealObserver.observe(el); });
    }
  }
});
  } catch(e) { console.error(e); }
})();

})();
